<!--
	name: PopMenu   Version: V3.0   by: coon    publish: 2024/07/04;
	include:

	功能：该组件用于实现
	可提供如下功能, 支持的形态及功能有:
		1.  在鼠标点击位置显示
		2.  动态设置菜单项
	组件调用参数:
		参数名           必要性    值域          说明

	输出的值:

	外部调用方法:
		无
-->

<template>
	<div id="idWinPanel" ref="idWinPanel" style="position:absolute; left:0px; top:0px; width:100%; height:100%; border:0px solid red; display:none;" @mouseout="onMouseOut">
		<div id="idPopWinPanel" ref="idPopWinPanel">

		</div>
	</div>
</template>

<script>

export default {
	name: 'PopMenu',
	props:['ctrl'],
	data () {
		return {
			menuLeft: 0,
			menuTop: 0,
		}
	},
	mounted: function(){

		this.ctrl.self = this;
	},
	computed:{

	},
	methods:{
		onShow: function( e, menuList ){
			this.menuLeft = e.clientX;
			this.menuTop  = e.clientY;
			this.$refs["idWinPanel"].style["display"] = "block";

			let pan=this.$refs["idPopWinPanel"];
			pan.innerHTML = "";
			for( let i=0; i<menuList.length; i++ )
			{
				let item=document.createElement("div");
				pan.appendChild( item );
				item.setAttribute("class", "RMenuItem");
				item.innerText = menuList[i].name;
				let that=this;
				item.onclick = function(){
					menuList[i].rcall( menuList[i].recId, menuList[i].newV );
					that.$refs["idWinPanel"].style["display"] = "none";
				};
			}

			this.onResize();
		},
		onResize: function(){
			this.$refs["idPopWinPanel"].style["margin-left"] = this.menuLeft+"px";
			this.$refs["idPopWinPanel"].style["margin-top"]  = this.menuTop+"px";
		},
		onMouseOut: function( e ){
			e.stopPropagation();
			if( e.target.getAttribute("class")=="RMenuItem" ) return;

			this.$refs["idWinPanel"].style["display"] = "none";
		},
	}
}

</script>

<style scoped>

#idPopWinPanel{ position:absolute; z-index:1000; border:0px solid #ff0000; box-shadow:0 0 8px rgba(0, 0, 0, .8); background:#ffffff; border-radius:3px; display:flex; flex-direction:column; }

</style>



// WEBPACK FOOTER //
// popmenu.vue?2b66a34d